<template>
  <div class="baseball-data" v-if="typeOptions.length > 1">
    <div class="tabs">
      <van-tabs background="#FFFFFF" v-model="active" @change="changeTabs">
        <van-tab v-for="item in typeOptions" :name="item.value" :title="item.label" :key="item.value"></van-tab>
      </van-tabs>
    </div>
    <div class="list" v-if="active === 1">
      <div class="left">
        <div class="item">榜单类型</div>
        <div class="item" :class="selected === item.label ? 'selected' : ''" v-for="item in attachOptions"
          :key="item.label" @click="getDate(item.label)">{{ item.name }}</div>
      </div>
      <div class="right">
        <div class="title">
          <div class="t1">球员</div>
          <div class="t2">球队</div>
          <div class="t3">计数</div>
        </div>
        <div class="item" v-for="(item, i) in list" :key="i">
          <div class="t1">
            <div class="number">{{ i + 1 }}</div>
            <div class="overflow-text">{{ item.trueName }}</div>
          </div>
          <div class="team t2">
            <img :src="imageView(item.badge)" />
            <div class="overflow-text">{{ item.teamName }}</div>
          </div>
          <div class="t3">{{ item[selected] }}</div>
        </div>
      </div>
    </div>
    <div class="list" v-else-if="active === 2">
      <div class="left">
        <div class="item">榜单类型</div>
        <div class="item" :class="selected === item.label ? 'selected' : ''" v-for="item in pitchingOptions"
          :key="item.label" @click="getDate(item.label)">{{ item.name }}</div>
      </div>
      <div class="right">
        <div class="title">
          <div class="t1">球员</div>
          <div class="t2">球队</div>
          <div class="t3">计数</div>
        </div>
        <div class="item" v-for="(item, i) in list" :key="i">
          <div class="t1">
            <div class="number">{{ i + 1 }}</div>
            <div>{{ item.trueName }}</div>
          </div>
          <div class="team t2">
            <img :src="imageView(item.badge)" />
            <div class="overflow-text">{{ item.teamName }}</div>
          </div>
          <div class="t3">{{ item[selected] }}</div>
        </div>
      </div>
    </div>
    <div class="list" v-else-if="active === 3">
      <div class="left">
        <div class="item">榜单类型</div>
        <div class="item" :class="selected === item.label ? 'selected' : ''" v-for="item in catcherOptions"
          :key="item.label" @click="getDate(item.label)">{{ item.name }}</div>
      </div>
      <div class="right">
        <div class="title">
          <div class="t1">球员</div>
          <div class="t2">球队</div>
          <div class="t3">计数</div>
        </div>
        <div class="item" v-for="(item, i) in list" :key="i">
          <div class="t1">
            <div class="number">{{ i + 1 }}</div>
            <div class="overflow-text">{{ item.trueName }}</div>
          </div>
          <div class="team t2">
            <img :src="imageView(item.badge)" />
            <div class="overflow-text">{{ item.teamName }}</div>
          </div>
          <div class="t3">{{ item[selected] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMMatchBaseBallStats, getBMMatchPlayerBaseBallStats } from '@/api/match'
import Vue from 'vue';
import { Tabs, Tab, Toast } from 'vant';
Vue.use(Tabs).use(Tab).use(Toast);
import { attachOptions, catcherOptions, pitchingOptions } from "@/config";
import { QNImageUtil } from "@/utils";

export default {
  data() {
    return {
      typeOptions: [],
      matchId: '',
      catcherCheckboxes: [],
      pitchingCheckboxes: [],
      attachCheckboxes: [], // 进攻
      active: 1, // 选中的tab
      selected: '',
      attachOptions: attachOptions,
      pitchingOptions: pitchingOptions,
      catcherOptions: catcherOptions,
      list: [],
      keyList: []
    };
  },
  created() {
    this.matchId = this.$route.query.matchId
    this.getBMMatchBaseBallStats()
  },
  methods: {
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getBMMatchBaseBallStats() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchBaseBallStats(params).then(res => {
        if (res) {
          const { data } = res
          const typeOptions = []
          const bas = data.baseballAttachStats && data.baseballAttachStats.split('|') || []
          const attachCheckboxes = {}
          bas.forEach(psf => {
            attachCheckboxes[psf] = true
          })
          if (bas.length > 0) {
            this.keyList.push(bas[0])
          }
          this.attachCheckboxes = attachCheckboxes
          if ('{}' !== JSON.stringify(this.attachCheckboxes)) {
            typeOptions.push({ value: 1, label: '进攻' })
          }
          const bps = data.baseballPitchingStats && data.baseballPitchingStats.split('|') || []
          const pitchingCheckboxes = {}
          bps.forEach(psf => {
            pitchingCheckboxes[psf] = true
          })
          if (bps.length > 0) {
            this.keyList.push(bps[0])
          }
          this.pitchingCheckboxes = pitchingCheckboxes
          if ('{}' !== JSON.stringify(this.pitchingCheckboxes)) {
            typeOptions.push({ value: 2, label: '投手' })
          }
          const bcs = data.baseballCatcherStats && data.baseballCatcherStats.split('|') || []
          const catcherCheckboxes = {}
          bcs.forEach(psf => {
            catcherCheckboxes[psf] = true
          })
          if (bcs.length > 0) {
            this.keyList.push(bcs[0])
          }
          this.catcherCheckboxes = catcherCheckboxes
          if ('{}' !== JSON.stringify(this.catcherCheckboxes)) {
            typeOptions.push({ value: 3, label: '接手' })
          }
          this.typeOptions = typeOptions
          this.active = typeOptions[0]?.value
          this.selected = this.keyList[0]
          this.attachOptions = this.attachOptions.filter(item => this.attachCheckboxes[item.label])
          this.pitchingOptions = this.pitchingOptions.filter(item => this.pitchingCheckboxes[item.label])
          this.catcherOptions = this.catcherOptions.filter(item => this.catcherCheckboxes[item.label])
          this.getDate(this.selected)
        }
      })
    },
    getBMMatchPlayerBaseBallStats() {
      const params = {
        matchId: this.matchId,
        pageSize: 999,
        pageNum: 1,
        sortOrder: 'descending',
        orderBy: this.selected
      }
      getBMMatchPlayerBaseBallStats(params).then(res => {
        this.list = res.data.list
      })
    },
    getDate(id) {
      this.selected = id
      this.getBMMatchPlayerBaseBallStats()
    },
    changeTabs(i) {
      this.selected = this.keyList[i - 1]
      this.getBMMatchPlayerBaseBallStats()
    }
  },
};
</script>

<style scoped lang="scss">
.baseball-data {
  .tabs {
    height: 50px;
  }

  .list {
    margin-top: 12px;
    display: flex;
    font-size: 12px;
    height: calc(100vh - 50px);

    .left {
      background-color: #F2F2F2;
      width: 100px;

      .item {
        text-align: center;
        width: 100px;
        height: 40px;
        line-height: 40px;
      }

      .selected {
        background: #009DFF;
        color: #fff;
      }
    }

    .right {
      flex: 1;

      .title {
        display: flex;
        background-color: #F2F2F2;
        height: 40px;
        line-height: 40px;
        justify-content: space-between;
        padding: 0 12px;
        box-sizing: border-box;

        .t1 {
          padding-left: 12px;
          box-sizing: border-box;
        }

        .t2 {
          padding-left: 18px;
          box-sizing: border-box;
        }
      }

      .item {
        height: 40px;
        line-height: 40px;
        display: flex;
        padding: 0 12px;
        box-sizing: border-box;
        justify-content: space-between;

        .team {
          display: flex;
          align-items: center;
        }

        .t1 {
          display: flex;
        }

        img {
          height: 35px;
          width: 35px;
          margin-right: 4px;
        }
      }

      .t1 {
        width: 35%;

        .number {
          color: rgb(244, 113, 73);
          font-size: 14px;
          margin-right: 4px;
        }
      }

      .t2 {
        width: 55%;
      }

      .t3 {
        width: 10%;
        text-align: right;
      }
    }
  }
}
</style>